import { Component, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as ProfileActions from '@profile/profile.actions';
import * as fromProfile from '@profile/profile.reducers';

import { NewDocType } from '@shared/models/Profile';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-transfer-3a-account',
  templateUrl: './transfer-3A-account.html',
  styleUrls: ['./transfer-3A-account.scss'],
  standalone: false
})
export class Transfer3AAccountComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  transferDoc: NewDocType;
  disabledDownloadLink = false;

  constructor(
    private store: Store,
    private sharedService: SharedService
  ) {
    this.store.dispatch(ProfileActions.fetchCustomerDocs());
    this.store.pipe(select(fromProfile.selectTransfer3ADoc), takeUntil(this.onDestroy$)).subscribe((doc) => {
      if (!doc.length) {
        this.disabledDownloadLink = true;
        return;
      }

      this.disabledDownloadLink = false;
      this.transferDoc = doc[0];
    });
  }

  downloadTransferDoc(): void {
    this.sharedService.downloadCustomerDocuments(
      this.transferDoc.attributes.translated_title,
      this.transferDoc.attributes.type_id,
      this.transferDoc.id
    );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
